let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fPczA")).then(() => parcelRequire('8f4JT'));